import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./NamePick.css";

const SEARCH_CUSTOMERS = "https://www.lianfoong.com/api/customers/search-by-name"; // ?q=

/** Safe formatter: 'YYYY-MM-DD' or ISO → 'ddMMYYYY' */
const fmtDDMMYYYY = (s) => {
  if (!s) return "-";
  const str = String(s);
  const datePart = str.split("T")[0]; // '2025-09-26'
  const bits = datePart.split("-");
  if (bits.length === 3) {
    const [yyyy, mm, dd] = bits;
    return `${dd.padStart(2, "0")}${mm.padStart(2, "0")}${yyyy}`;
  }
  const d = new Date(str);
  if (Number.isNaN(d.getTime())) return str;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}${mm}${yyyy}`;
};

export default function NamePick() {
  const { state } = useLocation();
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!state?.query) { nav("/enquiry/name"); return; }
    (async () => {
      try {
        const res = await axios.get(SEARCH_CUSTOMERS, { params: { q: state.query } });
        setRows(res.data || []);
      } catch (e) {
        setErr(e?.response?.data || "Search failed");
      }
    })();
  }, [state, nav]);

  const pick = (cust) => {
    // forward their NRIC to months page to reuse NRIC flow
    nav("/enquiry/nric/months", { state: { value: cust.nirc, fromName: state.query } });
  };

  return (
    <div className="namePick">
      <div className="np-header">
        <h2>Pick Customer — “{state?.query}”</h2>
        {!!rows && <div className="np-count">{rows.length} result{rows.length === 1 ? "" : "s"}</div>}
      </div>

      {err && <div className="np-alert np-error">{String(err)}</div>}

      {!rows ? (
        <div className="np-loading">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="np-empty">No customers found</div>
      ) : (
        <div className="np-table-wrap">
          <table className="np-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>NRIC</th>
                <th>Last Seen</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.nirc} className="np-clickable" onClick={() => pick(c)}>
                  <td>{c.name}</td>
                  <td className="mono">{c.nirc}</td>
                  <td className="mono">{c.updatedAt ? fmtDDMMYYYY(c.updatedAt) : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="np-row">
        <button className="np-btn" onClick={() => nav("/enquiry/name")}>New Name</button>
      </div>
    </div>
  );
}
